const myStorage = localStorage
const mySession = sessionStorage

// ---- storage ----
export function storageSave(key, value) {
    myStorage.setItem(key, value)
}

export function storageDel(key) {
    myStorage.removeItem(key)
}

export function storageClear() {
    myStorage.clear()
}

export function storageQuery(key) {
    return myStorage.getItem(key)
}

// ---- session ----
export function sessionSave(key, value) {
    mySession.setItem(key, value)
}

export function sessionDel(key) {
    mySession.removeItem(key)
}

export function sessionClear() {
    mySession.clear()
}

export function sessionQuery(key) {
    return mySession.getItem(key)
}



// WEBPACK FOOTER //
// ./src/utils/storage.js